export default [
  {
    "id": "prod_OYOxZy5zeau3qS",
    "name": "XAPP AI Max",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "search": "true",
      "sku": "X Max"
    },
    "description": "AI Powered Chat, Intelligent Search, GBM"
  },
  {
    "id": "prod_OTWFLK7Zg3YOW5",
    "name": "Jobber Max Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "partner": "jobber",
      "search": "true",
      "sku": "JOB MAX"
    },
    "description": "AI Powered Chat, Intelligent Search, GBM, and Jobber Integration"
  },
  {
    "id": "prod_OTWELanEF9Frvb",
    "name": "Jobber Essentials Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "partner": "jobber",
      "search": "true",
      "sku": "JOB ESS"
    },
    "description": "AI Powered Chat , Intelligent Search and Jobber Integration"
  },
  {
    "id": "prod_OTWBkJ5zC7gwPE",
    "name": "Jobber Starter Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "partner": "jobber",
      "search": "false",
      "sku": "JOB STRT"
    },
    "description": "AI Powered Chat and Jobber Integration"
  },
  {
    "id": "prod_OTVhAvqgcNT8kl",
    "name": "XAPP AI Essentials",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "search": "true",
      "sku": "X ESS"
    },
    "description": "AI Powered Chat and Intelligent Search"
  },
  {
    "id": "prod_OTVaCIwOCO7KrD",
    "name": "XAPP AI Starter",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "search": "false",
      "sku": "X STRT"
    },
    "description": "AI Powered Chat"
  },
  {
    "id": "prod_OHSayEKfN87zZ8",
    "name": "LACRM Max Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "partner": "lacrm",
      "search": "true",
      "sku": "LACRM MAX"
    },
    "description": "AI powered chat, intelligent search, and GBM solutions integrated with the LACRM platform.  Includes enhanced reporting"
  },
  {
    "id": "prod_OHSXTXKLOTo3FO",
    "name": "LACRM Essentials Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "partner": "lacrm",
      "search": "true",
      "sku": "LACRM ESS"
    },
    "description": "AI powered chat and intelligent search solutions integrated with LACRM platform.  Includes enhanced reporting "
  },
  {
    "id": "prod_OHSVoiwdfyntlj",
    "name": "LACRM Starter Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "partner": "lacrm",
      "search": "false",
      "sku": "LACRM START"
    },
    "description": "Intelligent chat solution integrated with LACRM platform"
  },
  {
    "id": "prod_OANcoDlvmJ6VFI",
    "name": "Additional Chat",
    "active": true,
    "metadata": {},
    "description": "Chat as an add on channel for home services"
  },
  {
    "id": "prod_OANaY71XAvlDZK",
    "name": "Service Fusion Integration - HS",
    "active": true,
    "metadata": {},
    "description": "Integration for Service Fusion - Home Service"
  },
  {
    "id": "prod_OANYpT8vXcsyzW",
    "name": "Salesforce Integration - HS",
    "active": true,
    "metadata": {},
    "description": "Integration for Salesforce Home Services"
  },
  {
    "id": "prod_OA2AUH1GkVSh7r",
    "name": "ServiceTitan Integration - HS",
    "active": true,
    "metadata": {},
    "description": "ServiceTitan Integration"
  },
  {
    "id": "prod_OA29T2WJBN83yd",
    "name": "Additional GBM - HS",
    "active": true,
    "metadata": {},
    "description": "GBM as an add on channel for home services"
  },
  {
    "id": "prod_OA27nOGdsIeyBZ",
    "name": "Additional  Search - HS",
    "active": true,
    "metadata": {},
    "description": "Site search as an add on channel for home services"
  },
  {
    "id": "prod_OA262xa8x9IZyK",
    "name": "AI Powered Chat - HS",
    "active": true,
    "metadata": {},
    "description": "AI powered web chat for home services"
  },
  {
    "id": "prod_OA13o4yo0cd7h1",
    "name": "AI for Home Services - Early Adopter 1 Channel",
    "active": true,
    "metadata": {},
    "description": "AI-powered assistant via one of the following channels: web chat, search or GBM."
  }
]